(() => {
  const CART_SELECTOR = '.fv__cart, .fvp__cart, .fvi__cart';

  const cartIconMarkup = `
    <span class="flowever-cart-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">
        <path d="M3.5 4.5h2.1l1.95 9.15a2 2 0 0 0 1.96 1.58h7.48a2 2 0 0 0 1.96-1.58L20.5 7H6.15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="10" cy="19.5" r="1.15" fill="currentColor"/>
        <circle cx="18" cy="19.5" r="1.15" fill="currentColor"/>
      </svg>
    </span>`;

  function isEnglish() {
    return (document.documentElement.lang || 'fr').toLowerCase().startsWith('en');
  }

  function cleanCount(value) {
    const match = String(value || '').match(/\d+/);
    return match ? match[0] : '0';
  }

  function iconifyCart(link) {
    if (!(link instanceof Element)) return;

    if (link.dataset.floweverCartIconified !== 'true') {
      const existingCount = link.querySelector('[data-cart-count]');
      const count = cleanCount(existingCount ? existingCount.textContent : '0');

      link.dataset.floweverCartIconified = 'true';
      link.classList.add('flowever-cart-icon-only');
      link.setAttribute('aria-label', isEnglish() ? 'View cart' : 'Voir le panier');
      link.innerHTML = `${cartIconMarkup}<span class="flowever-cart-count" data-cart-count>${count}</span>`;
    }

    const countEl = link.querySelector('[data-cart-count]');
    if (countEl) {
      const normalized = cleanCount(countEl.textContent);
      if (countEl.textContent !== normalized) countEl.textContent = normalized;
      countEl.classList.toggle('is-empty', normalized === '0');
    }
  }

  function moveLanguageSwitcher() {
    const switcher = document.querySelector('.flowever-language-switcher');
    const footerBottom = document.querySelector('.flowever-footer__bottom');
    if (!switcher || !footerBottom) return;

    let slot = footerBottom.querySelector('[data-flowever-language-slot]');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'flowever-footer__language';
      slot.setAttribute('data-flowever-language-slot', '');
      footerBottom.appendChild(slot);
    }

    switcher.classList.remove('flowever-language-switcher--floating');
    switcher.classList.add('flowever-language-switcher--footer');
    if (switcher.parentElement !== slot) slot.appendChild(switcher);
  }

  function syncControls() {
    document.querySelectorAll(CART_SELECTOR).forEach(iconifyCart);
    moveLanguageSwitcher();
  }

  function boot() {
    syncControls();

    const observer = new MutationObserver(() => syncControls());
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();